import * as React from 'react';

import { CPDTrapContainer } from 'shared/containers/valuationTraps/HomeownerTrap/CPDHomeownerTrap';
import { MyHomeHomeownerTrapContainer } from 'shared/containers/valuationTraps/HomeownerTrap/MyHomeHomeownerTrap';
import { EHomeownerTrap } from 'shared/containers/valuationTraps/HomeownerTrap/types';
import { useHomeownerTrapVisible } from 'shared/containers/valuationTraps/hook/useHomeownerTrapVisible';

export const HomeownerTrapContainer: React.FC = () => {
  const homeownerTrap = useHomeownerTrapVisible();

  switch (homeownerTrap) {
    case EHomeownerTrap.myHome:
      return <MyHomeHomeownerTrapContainer />;
    case EHomeownerTrap.cpd:
      return <CPDTrapContainer />;
    default:
      return null;
  }
};
